import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';
import NotifyMailroomSwitch from 'src/components/NotifyMailroomSwitch';

import { ActionComponentProps } from '../../index';
import { buildUpdatePiecesRequest } from './helper';

export const RequestReturnToSender = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();
  const [shouldNotify, setShouldNotify] = useState(true);

  const confirmAction = async () => {
    const requestData = buildUpdatePiecesRequest({
      mailpieces,
      action: PieceAction.RequestReturnToSender,
      isForce,
      shouldNotify,
    });

    await updatePieces(requestData).unwrap();

    onActionFinish();
  };

  const content = (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {mailpieces.length === 1 ? (
          'Are you sure you would like this item to be returned to its sender?'
        ) : (
          <>
            Are you sure you would like <strong>{mailpieces.length}</strong> items to be returned to their senders?
          </>
        )}
      </Typography>

      {isForce && <NotifyMailroomSwitch checked={shouldNotify} onChange={() => setShouldNotify(!shouldNotify)} />}
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Request return to sender' : 'Request return to sender for selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Submit"
      cancelButtonTitle="Cancel"
    />
  );
};
